export enum Watermark {
  POPULAR = "popular",
  TOP = "top",
}
